import Request from "lib/request";

export const getData = () => {
  return Request({
    url: "upload",
    method: "get",
  });
};
export const upload = (file, usage) => {
  var formData = new FormData();
  formData.append("file", file);
  formData.append("usage", usage);
  return Request({
    url: "upload",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};